export const ratingColor = (ratingPercent: number) => {
  if (ratingPercent <= 0.6) return 'rgb(208,2,27)'
  else if (ratingPercent <= 0.8) return 'rgb(245,166,35)'
  else return 'rgb(126,211,33)'
}
